import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import Snackbar from "../../../Snackbar";
import QueOptionsForResponse from "./QueOptionsForResponse";
import { evaluateQuestion } from "./AnswerEvaluateEngine";
import { handleAttemptTestActions } from "../../../store/actions/QuizAPI/createNewMockTest";

import { useParams } from "react-router-dom";
import { sec } from "mathjs";
  
const QuestionOptionsStatic= ({quizArr,setAttempt,section,topic,responseArray,answerResponse,themeColor,questionObject,questionType})=>{ 
  

   const {courseId} = useParams();

   const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
    const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
           
  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
  const [attemptData, setAttemptData] = useState(null); 
  
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      
               const user = useSelector((state)=>state?.user?.user);
      
                       
                       
                                  
                                  
            const [isLockSections, setIsLockSections] = useState();
                               
                              const [animate, setAnimate] = useState(false);
                
                 const [loader , setLoader] =useState({status:true});
        
            
                   const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
                   const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
                  );
                  
                      const userData =useSelector((state)=>state?.user?.user);
                     const AppToken = useSelector((state)=>state?.user?.user?.appToken);
                     const appId = useSelector((state)=>state?.user?.user?.appId);
                      
 const [itemArr, setItemArr] = useState([]);
  
     useEffect(() => {
        setItemArr( questionObject?.options?.length?questionObject?.options:questionType=="NAT"||questionType=="Drag Matching"?questionObject?.options:questionType=="True-False"?questionObject?.options:[])

       
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
    
      useEffect(()=>{
         let rawData= (section?.secQuestions?.find(q =>
        q.ID == questionObject?.ID 
      ))?.rawData;
    setAttemptData(rawData?JSON.parse(rawData):[])  
    
      },[])
  





  
     const fireHandleAttemptTestActions=(actionType,queData=null)=>{
    
     let visited= (section?.secQuestions?.find(q =>
        q.ID == questionObject?.ID 
      ))?.visited;
       let answered= (section?.secQuestions?.find(q =>
        q.ID == questionObject?.ID 
      ))?.answered;
      let marked= (section?.secQuestions?.find(q =>
        q.ID == questionObject?.ID 
      ))?.marked;
      
   let timer= (responseArray?.find(
  q => q?.ID?.toString() === questionObject?.ID?.toString()
))?.timer;

             if(!userEmail) { dispatch({ type: "LoginSignUpPopUp",payload:"login"})}
             let   requestData={};
         if(actionType=="startAttempt"){
          requestData={userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:quizArr?.ID,attemptId:quizArr?.attemptId,
      actionType:"startAttempt"}
         }   if(actionType=="submitAttempt"){
          requestData={userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:quizArr?.ID,attemptId:quizArr?.attemptId,
      actionType:"submitAttempt"}
         } 
         if(actionType=="pauseOrResume"){
          requestData={userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:quizArr?.ID,attemptId:quizArr?.attemptId,
      actionType:"pauseOrResume"}
         } if(actionType=="getAllAttemptsInfo"){
          requestData={userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,testId:quizArr?.ID,attemptId:quizArr?.attemptId,
      actionType:"getAllAttemptsInfo"}
         } if(actionType=="saveResponse"){
          requestData={userEmail:userEmail?userEmail:"",
        currentToken:currentToken?currentToken:"",productType:"course", courseId:courseId,
        testId:quizArr?.ID,attemptId:quizArr?.attemptId,
        questionId:queData?.questionId,sectionId:section?.ID,topicId:questionObject?.topicId!=null?questionObject?.topicId:"",queType:queData?.queType,status:queData?.status,
        marksAwarded:queData?.score ,negativeMarks:"",timeTaken:timer?timer:0,responseSpeed:"",visited:visited=="visited"?1:0,answered:answered=="answered"?1:0,marked:marked=="marked"?1:0,
        rawData:JSON.stringify(queData),
      actionType:"saveResponse"}
         } 
        //  console.log(requestData)
          
         
                 const apiData = dispatch(handleAttemptTestActions(requestData));
                 /* get response as Promise   */
                 apiData.then(response => {
                
           console.log(response)
                   
               
                 }).catch(error => {
                
                   //popup of error Info
                   setResponseMessage("Something Went Wrong...");
                     
                   setSnackbarColor("#958FDA");
                
                   
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)
                  
                 });
            }
   











    const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

 

     return(<>
              {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )} 
    <div > 
        {/* <button onClick={()=>{fireHandleAttemptTestActions("saveResponse")}} >Pause Testt</button> */}
    <div  className=""style={{margin:"10px"}}> 
   
               <div  className=" " style={{borderRadius:"25px",}}>
  <div  className=" " >
    
  
<div  className=""style={{ 
     transform: animate ? 'translateY(0)' : 'translateY(-50px)',
     opacity: animate ? 1 : 0,
     transition: 'transform 2s ease, opacity 1s ease', 
   }}>
{flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.ID} 
          >
        
            <div
           
            ><QueOptionsForResponse question={questionObject} attempt={attemptData} setAttempt={(v)=>{
              // 
       

              if(v?.queType!=="Drag Matching"&&v?.queType!=="Drag Ordering"){
                //  console.log(evaluateQuestion(questionObject,v));
       
             fireHandleAttemptTestActions("saveResponse",evaluateQuestion(questionObject,v))
             setAttempt(JSON.stringify(evaluateQuestion(questionObject,v)))
              }else{
                 setAttempt(JSON.stringify(v))
                 fireHandleAttemptTestActions("saveResponse",v)
                //  console.log(v);
              }
             
             }} answerResponse={(status)=>{answerResponse(status)}}
                
             themeColor={themeColor} questionType={questionType} element={item}  index={index} key={item.ID} 
               isLockSections={isLockSections} lockTimeSent={item.lockTime}
            
         optionText={item.optionText}  id={item.ID}  
           />
                </div>
          
          </div>)):'' }
  
   
    </div>  
     {flattenedDataLoading.length==0&&flattenedData.length==0&&questionType!=="Essay"? <div style={{fontSize:"28px",fontWeight:"bold",padding:"5px",marginTop:"45px",
                 paddingLeft:"10px",display:"flex",margin:"15px",justifyContent:"center",border:"3px solid rgba(144, 202, 249,0.41)",marginTop:"10px",background:"#ffffff",borderRadius:"15px",padding:"5px",
             display:"flex",justifyContent:"center"
            }}>
             No Option Found </div>:"" }
    
     <div align="center">


    </div>
    </div>   <div  className=""style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"50px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
         

        </div>  </div>  </div>  </div> 

      
                                    
     </>)  
   }
   export default QuestionOptionsStatic;